import React, { useEffect, useRef } from "react";
import CareerTab from "./CareerTab";
import ContactsTab from "./ContactsTab";
import SkillsTab from "./SkillsTab";

const MainTab = ({ currentTab, setCurrentTab }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef?.current) {
      if (currentTab !== "Main") contentRef.current.className = "contentUpped";
    }
  }, [currentTab]);

  return (
    <div className="content" ref={contentRef}>
      <div className="mainLabel">Dmitry Cherendieiev</div>
      <div className="subLabels">
        <ul className="menuUl">
          <li onClick={() => setCurrentTab("Contacts")} className="menuLi">
            Contacts
          </li>
          <li onClick={() => setCurrentTab("Skills")} className="menuLi">
            Skills
          </li>
          <li onClick={() => setCurrentTab("Career")} className="menuLi">
            Career
          </li>
        </ul>
      </div>
      {currentTab === "Skills" && <SkillsTab />}
      {currentTab === "Contacts" && <ContactsTab />}
      {currentTab === "Career" && <CareerTab />}
    </div>
  );
};

export default MainTab;
